module.exports =
  normalizeNumber: (number) ->
    number = number.replace(/[^\d\+]/g, '')

    # Особый случай для российских и украинских номеров
    # TODO: не очень общно, но будет работать в ближайшее время
    phoneRE = /^(([\+]{0,1})([78]|(38))){0,1}(\d{10})$/

    phoneRes = phoneRE.exec(number)

    if phoneRes and phoneRes.length >= 6
      n = phoneRes[5]
      countryCode = phoneRes[3]
      countryCode = 7 if countryCode == 8
      number = "+#{countryCode} (#{n[0...3]}) #{n[3...6]}-#{n[6...8]}-#{n[8...10]}"

    number